import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { XCircle } from "lucide-react";

const LOGO = "https://customer-assets-m6fa6gv7.emergentagent.net/job_equity-support/artifacts/114243fe_edi%20logo.png";

export default function PaymentCancel() {
    return (
        <div className="min-h-screen bg-[#FBF7F0] text-[#14203A] font-sans flex flex-col" data-testid="payment-cancel-page">
            <header className="border-b border-[#eee3d0]">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-20 flex items-center">
                    <Link to="/"><img src={LOGO} alt="EDI Connect" className="h-14 w-auto" /></Link>
                </div>
            </header>
            <div className="flex-1 flex items-center justify-center px-4 py-20">
                <div className="max-w-lg w-full bg-white rounded-2xl border border-[#eee3d0] p-10 text-center">
                    <div className="h-16 w-16 rounded-full bg-[#C58B2B]/10 flex items-center justify-center mx-auto"><XCircle className="h-9 w-9 text-[#C58B2B]" /></div>
                    <h1 className="font-display text-2xl font-bold mt-6">Checkout cancelled</h1>
                    <p className="mt-3 text-[#3d4657]">No payment was taken. You can become a member any time — we're here whenever you're ready.</p>
                    <Link to="/"><Button className="mt-8 bg-[#14203A] hover:bg-[#22304f] text-white rounded-full px-8" data-testid="cancel-home-btn">Back to home</Button></Link>
                </div>
            </div>
        </div>
    );
}
